import React from "react";
import {useTranslation} from "react-i18next";
import {driverName} from "utils/utility";
import {clsx} from "clsx";
import {Driver} from "types/entities/Driver";
import {getTextClassNameByPersonType} from "utils/driverUtils";
import {PersonType} from "types/enums/PersonType";
import AccessTicketDriversAssignUserButton
    from "pages/Front/Booking/BookingLogin/components/ReservationDetailComponents/AccessTicketDriversAssignUserButton";
import FeatherIcon from "components/FeatherIcon";

const AccessTicketDriversAssignUser = (props: {driver: Driver; onClick: () => void; isDisableDriver?: boolean}) => {
    const {t} = useTranslation();
    return (
        <AccessTicketDriversAssignUserButton
            className={"AccessTicketDriversAssignUser"}
            backIcon={<FeatherIcon name={"plus-circle"} className={"size-[20px] md:size-[30px]"} strokeWidth={2} />}
            frontIcon={<FeatherIcon name={"user"} strokeWidth={2} className={clsx("size-[20px] md:size-[30px]", getTextClassNameByPersonType(props.driver.person_type))} />}
            isDisableDriver={props.isDisableDriver}
            onClick={props.onClick}
        >
            <div className={"AccessTicketDriversAssignUserInner flex flex-row grow"}>
                <div className={"flex flex-row grow max-w-[400px] justify-between items-start gap-x-4 py-1"}>
                    <div className="flex flex-col items-start  font-medium text-left ">
                        <span className={"leading-normal"}>{driverName(props.driver)}</span>
                        <span
                            className={clsx(
                                "font-light text-xxs md:text-xs leading-[1]",
                                getTextClassNameByPersonType(props.driver.person_type as unknown as PersonType)
                            )}
                        >
                            {t("Main account")}
                        </span>
                    </div>
                    {props.driver.age && (
                        <div className={"h-full flex flex-col items-center justify-center grow text-xs md:text-base font-light text-black"}>{props.driver.age}&nbsp;J.</div>
                    )}
                </div>
            </div>
        </AccessTicketDriversAssignUserButton>
    );
};

export default AccessTicketDriversAssignUser;
